// api/notificationAPI.ts
import axiosClient from './axiosClient';

export interface Notification {
  id: number;
  title: string;
  message: string;
  type: 'info' | 'success' | 'warning' | 'error';
  related_entity_type: string;
  related_entity_id: number;
  user_id: number;
  is_read: boolean;
  created_at: string;
}

export const getNotifications = async (
  unreadOnly: boolean = false
): Promise<Notification[]> => {
  const response = await axiosClient.get(`/notifications/`, {
    params: { unread_only: unreadOnly }
  });
  return response.data;
};

export const markNotificationAsRead = async (
  notificationId: number
): Promise<void> => {
  await axiosClient.post(`/notifications/${notificationId}/read`);
};

export const markAllNotificationsAsRead = async (): Promise<void> => {
  await axiosClient.post('/notifications/mark-all-read');
};

export const createNotification = async (notificationData: {
  title: string;
  message: string;
  type: 'info' | 'success' | 'warning' | 'error';
  related_entity_type: string;
  related_entity_id: number;
  user_id: number;
}): Promise<Notification> => {
  const response = await axiosClient.post('/notifications/', notificationData);
  return response.data;
};

export const createAssetRequestNotification = async (requestData: {
  asset_name: string;
  request_id: number;
  user_id: number;
  user_name: string;
}): Promise<Notification> => {
  return createNotification({
    title: 'New Asset Request',
    message: `${requestData.user_name} requested asset: ${requestData.asset_name}`,
    type: 'info',
    related_entity_type: 'asset_request',
    related_entity_id: requestData.request_id,
    user_id: requestData.user_id
  });
};

export const createAssetApprovalNotification = async (approvalData: {
  asset_name: string;
  request_id: number;
  user_id: number;
  approver_name: string;
  status: 'approved' | 'rejected';
}): Promise<Notification> => {
  const statusText =
    approvalData.status === 'approved' ? 'approved' : 'rejected';
  return createNotification({
    title: `Asset Request ${statusText}`,
    message: `${approvalData.approver_name} ${statusText} your request for: ${approvalData.asset_name}`,
    type: approvalData.status === 'approved' ? 'success' : 'error',
    related_entity_type: 'asset_request',
    related_entity_id: approvalData.request_id,
    user_id: approvalData.user_id
  });
};
